import { render, staticRenderFns } from "./AssignmentReply.vue?vue&type=template&id=24c1b0d7&scoped=true&"
import script from "./AssignmentReply.vue?vue&type=script&lang=js&"
export * from "./AssignmentReply.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentReply.vue?vue&type=style&index=0&id=24c1b0d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c1b0d7",
  null
  
)

export default component.exports